import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import {Spinner} from "react-bootstrap";

const loading = (props) => {
    let show = props.show;

    if (show){
        return (
            <div className='p-5'>
                <h1><Spinner animation="border" variant="secondary"/> Loading...</h1>
            </div>
        );
    } else {
        return (
            <div />
        );
    }

};

export default loading;